import React from 'react';
import { Users, Star, BookOpen, Trophy, School, Building2, Wrench, BookMarked, Moon, Laptop } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-darker py-10 border-y border-white/10" data-id="element-145">
      <div className="max-w-5xl mx-auto px-4" data-id="element-146">
        {/* Main Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8 text-center" data-id="element-147">
          <div className="flex flex-col items-center" data-id="element-148">
            <Users className="w-6 h-6 text-brand-accent mb-1" data-id="element-149" />
            <span className="font-heading font-bold text-lg text-white" data-id="element-150">
              +500
            </span>
            <span className="text-xs text-gray-400 font-body" data-id="element-151">
              docentes ya lo usan
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-152">
            <Star className="w-6 h-6 text-brand-accent mb-1" fill="currentColor" data-id="element-153" />
            <span className="font-heading font-bold text-lg text-white" data-id="element-154">
              4.9/5
            </span>
            <span className="text-xs text-gray-400 font-body" data-id="element-155">
              valoración promedio
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-156">
            <BookOpen className="w-6 h-6 text-brand-accent mb-1" data-id="element-157" />
            <span className="font-heading font-bold text-lg text-white" data-id="element-158">
              +5 Tomos
            </span>
            <span className="text-xs text-gray-400 font-body" data-id="element-159">
              de contenido profesional
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-160">
            <Trophy className="w-6 h-6 text-brand-accent mb-1" data-id="element-161" />
            <span className="font-heading font-bold text-lg text-white" data-id="element-162">
              #1
            </span>
            <span className="text-xs text-gray-400 font-body" data-id="element-163">
              Sistema elegido en Argentina
            </span>
          </div>
        </div>

        <div className="w-full h-px bg-white/10 mb-6" data-id="element-164"></div>

        {/* Contexts - compact on mobile */}
        <div className="text-center" data-id="element-165">
          <h3 className="text-sm font-heading font-bold text-gray-300 mb-3 uppercase" data-id="element-166">
            Utilizado en todo tipo de contextos:
          </h3>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-167">
            {[{
            icon: <School className="w-3.5 h-3.5" data-id="element-168" />,
            label: 'Escuelas Públicas'
          }, {
            icon: <Building2 className="w-3.5 h-3.5" data-id="element-169" />,
            label: 'Colegios Privados'
          }, {
            icon: <Wrench className="w-3.5 h-3.5" data-id="element-170" />,
            label: 'Institutos Técnicos'
          }, {
            icon: <BookMarked className="w-3.5 h-3.5" data-id="element-171" />,
            label: 'Bachilleratos'
          }, {
            icon: <Moon className="w-3.5 h-3.5" data-id="element-172" />,
            label: 'Escuelas de Adultos'
          }, {
            icon: <Laptop className="w-3.5 h-3.5" data-id="element-173" />,
            label: 'Educación a Distancia'
          }].map((item, idx) => <div key={idx} className="flex items-center gap-1.5 text-gray-400 bg-white/5 px-3 py-1.5 rounded-full border border-white/5 text-xs font-body" data-id="element-174">
                <span className="text-brand-accent" data-id="element-175">{item.icon}</span>
                <span data-id="element-176">{item.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}